import { ModalFuncProps } from 'antd';

export const baseProps: ModalFuncProps = {
  centered: true,
  closable: true,
  width: 650,
};
